import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createEmployee } from '@/apis/employees'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { CreateEmployeeRequest, CreateEmployeeResponse } from '@/types/apis/employees'

export const useCreateEmployees = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<CreateEmployeeResponse>()

  const create = useCallback(
    async (request: CreateEmployeeRequest) => {
      try {
        setLoading(true)
        const res = await createEmployee(request)
        setResponse(res)
        openNotification({ description: t('pages.employees.create.createSuccessfully') })
        navigate(routes.employees.path)
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createEmployee: create,
    response,
  }
}
